import { render, staticRenderFns } from "./StampItem.vue?vue&type=template&id=38e8a977&scoped=true&"
import script from "./StampItem.vue?vue&type=script&lang=js&"
export * from "./StampItem.vue?vue&type=script&lang=js&"
import style0 from "@/styles/components/LogoItem/LogoItem.less?vue&type=style&index=0&id=38e8a977&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e8a977",
  null
  
)

export default component.exports